import React, { Component } from 'react';
import {
    Modal,
    Row,
    Typography,
    Button,
    Spin,
} from 'antd';
import {
    BankOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux';
import ButtonItem from '../../../Components/ButtonItem';

const { Title, Text } = Typography;


class ModalPago extends Component {

    state = {
        loading: false,
        bancoSeleccionado: null,
        bancoSeleccionadoNombre: '',
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    handleConfirmarBanco = () => {
        this.props.onConfirmarBanco(this.state.bancoSeleccionado);
    }

    render() {
        return (
            <Modal
                title={null}
                visible={this.props.visible}
                onCancel={this.handleCancel}
                footer={null}
                width={700}
                centered
                closable={false}
                maskClosable={false}
                style={{ borderRadius: '8px' }}
                zIndex={3000}
            >
                <Spin spinning={this.state.loading} tip="Cargando bancos...">
                    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '300px' }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                            backgroundColor: 'white',
                            padding: '10px 20px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                            <Title level={3} style={{ margin: 0, color: '#1976d2' }}>Selecciona un banco para tarjeta</Title>
                            <Button
                                type="text"
                                icon={<CloseOutlined />}
                                onClick={this.handleCancel}
                                style={{ fontSize: '16px' }}
                                disabled={this.state.loading}
                            />
                        </div>

                        {/* Bancos */}
                        <Row gutter={[16, 16]} justify="center">
                            {(this.props.bancosTarjeta && Array.isArray(this.props.bancosTarjeta)) ? this.props.bancosTarjeta.map((banco, index) => (
                                <div key={index} style={{ margin: '0 10px' }}>
                                    <div
                                        onClick={() => this.setState({ bancoSeleccionado: banco._id, bancoSeleccionadoNombre: banco.nombre })}
                                        style={{
                                            width: '220px', // 👈 Aquí controlas el ancho horizontal
                                            cursor: 'pointer',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            padding: '30px 20px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                            transition: '0.3s',
                                            border: this.state.bancoSeleccionado === banco._id ? `3px solid #4caf50` : '2px solid #e0e0e0',
                                        }}
                                    >
                                        <div style={{
                                            backgroundColor: '#e0f7fa',
                                            padding: '20px',
                                            borderRadius: '50%',
                                            marginBottom: '15px',
                                            display: 'inline-block'
                                        }}>
                                            <BankOutlined style={{ fontSize: '32px', color: '#1976d2' }} />
                                        </div>
                                        <Text strong style={{ display: 'block', fontSize: '16px', color: '#333' }}>{banco.nombre}</Text>
                                    </div>
                                </div>
                            )) : null}
                        </Row>

                        {/* Confirmar selección */}
                        <div style={{ marginTop: '30px' }}>
                            <ButtonItem
                                type="primary"
                                size="large"
                                disabled={!this.state.bancoSeleccionado || this.state.loading}
                                loading={this.state.loading}
                                onClick={this.handleConfirmarBanco}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    backgroundColor: '#00b5e2',
                                    borderColor: '#00b5e2',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}
                            >
                                {this.state.loading ? 'Procesando...' : `Seleccionar ${this.state.bancoSeleccionadoNombre || ''}`}
                            </ButtonItem>
                        </div>
                    </div>
                </Spin>
            </Modal>
        )
    }
}


const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalPago);